import { createStore } from 'redux';
import reducers from './reducers';

export function configureStore(initialState) {
  const store = createStore(reducers, initialState);

  // Vite HMR support
  if (import.meta.hot) {
    import.meta.hot.accept('./reducers', (newModule) => {
      if (newModule) {
        store.replaceReducer(newModule.default);
      }
    });
  }

  return store;
}

export default configureStore;
